import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import type { MarketplaceBrand, ResolvedPreviewHref } from "./MarketplaceItemPreviewCard.types";
import MarketplaceExternalOpenIcon from "./MarketplaceExternalOpenIcon";
interface MarketplaceCompactCtaProps {
  readonly resolvedPreviewHref: ResolvedPreviewHref;
  readonly ctaAriaLabel: string;
  readonly hideActions: boolean;
  readonly hasPrice: boolean;
  readonly priceValueText: string;
  readonly priceCurrencyText?: string | undefined;
  readonly marketplaceBrand: MarketplaceBrand | null;
}
export default function MarketplaceCompactCta(t0) {
  const $ = _c(18);
  const {
    resolvedPreviewHref,
    ctaAriaLabel,
    hideActions,
    hasPrice,
    priceValueText,
    priceCurrencyText,
    marketplaceBrand
  } = t0;
  const {
    href,
    target,
    rel
  } = resolvedPreviewHref;
  const hasMarketplaceBrand = marketplaceBrand !== null;
  const topRightCtaTopClass = hideActions ? "tw-top-3" : "tw-top-[5.5rem]";
  const topRightCtaSizeClass = hasPrice ? "tw-max-w-[12rem] tw-gap-x-1.5 tw-rounded-full tw-px-2.5 tw-py-1.5 tw-text-xs tw-font-semibold" : "tw-size-8 tw-rounded-lg";
  const t1 = `tw-absolute tw-right-3 tw-z-10 tw-inline-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-border-white/10 tw-bg-transparent tw-text-white tw-no-underline tw-backdrop-blur-md tw-transition-colors tw-duration-150 ${topRightCtaTopClass} ${topRightCtaSizeClass}`;
  let t2;
  if ($[0] !== hasMarketplaceBrand || $[1] !== marketplaceBrand) {
    t2 = hasMarketplaceBrand ? <Image src={marketplaceBrand.logoSrc} alt={`${marketplaceBrand.displayName} logo`} width={16} height={16} className="tw-h-4 tw-w-4 tw-flex-shrink-0 tw-rounded-sm tw-object-cover" /> : <MarketplaceExternalOpenIcon className="tw-size-3.5 tw-flex-shrink-0" testId="marketplace-item-cta-fallback-icon" />;
    $[0] = hasMarketplaceBrand;
    $[1] = marketplaceBrand;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== hasPrice || $[4] !== priceValueText) {
    t3 = hasPrice && <span className="tw-max-w-[8rem] tw-truncate" data-testid="marketplace-item-price">{priceValueText}</span>;
    $[3] = hasPrice;
    $[4] = priceValueText;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== hasPrice || $[7] !== priceCurrencyText) {
    t4 = hasPrice && priceCurrencyText && <span className="tw-max-w-[6rem] tw-truncate" data-testid="marketplace-item-price-currency">{priceCurrencyText}</span>;
    $[6] = hasPrice;
    $[7] = priceCurrencyText;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== ctaAriaLabel || $[10] !== href || $[11] !== rel || $[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== target) {
    t5 = <Link href={href} target={target} rel={rel} prefetch={false} className={t1} data-testid="marketplace-item-price" aria-label={ctaAriaLabel} onClick={_temp} onMouseDown={_temp2} onTouchStart={_temp3}>{t2}{t3}{t4}</Link>;
    $[9] = ctaAriaLabel;
    $[10] = href;
    $[11] = rel;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = target;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}
function _temp3(event_1) {
  return event_1.stopPropagation();
}
function _temp2(event_0) {
  return event_0.stopPropagation();
}
function _temp(event) {
  return event.stopPropagation();
}